import { getType } from "typesafe-actions";

import * as CartActions from "./actions";
import type { CartAction, IShoppingCartReducerState } from "./types";

const initialState: IShoppingCartReducerState = {
  cartData: null!,
  prevCartItemCount: 0,
  isSyncing: false,
  hasError: false,
  syncingCartData: null!,
  hasProductComments: true, // TODO: temp location - move inside of cartData - make dependant on industry (or vkOrg?)
  openCartItemCount: 0
};

// try to keep this as simple as possible, currently several cases are overloaded
export default function shoppingCartReducer(state: IShoppingCartReducerState = initialState, action: CartAction): IShoppingCartReducerState {
  switch (action.type) {
    case getType(CartActions.checkSyncStart):
    case getType(CartActions.fetchStart):
    case getType(CartActions.addItemsStart): {
      return {
        ...state,
        isSyncing: true
      };
    }

    case getType(CartActions.updateStart): {
      return {
        ...state,
        syncingCartData: action.payload,
        isSyncing: true
      };
    }

    case getType(CartActions.checkSyncFail):
    case getType(CartActions.fetchFail):
    case getType(CartActions.updateFail):
    case getType(CartActions.addItemsFail): {
      return {
        ...state,
        hasError: true,
        isSyncing: false,
        syncingCartData: null!
      };
    }

    case getType(CartActions.fetchSuccess):
    case getType(CartActions.updateSuccess):
    case getType(CartActions.addItemsSuccess): {
      let prevCartItemCount = 0;
      prevCartItemCount += state && state.cartData && state.cartData.positions && state.cartData.positions.length ? state.cartData.positions.length : 0;
      prevCartItemCount +=
        state && state.cartData && state.cartData.onRequestPositions && state.cartData.onRequestPositions.length ? state.cartData.onRequestPositions.length : 0;
      return {
        ...state,
        prevCartItemCount,
        isSyncing: false,
        hasError: false,
        syncingCartData: null!,
        cartData: action.payload
      };
    }

    case getType(CartActions.checkSyncSuccess): {
      const { numTransfers, remainingChildTransactions } = action.payload;
      return {
        ...state,
        isSyncing: false,
        hasError: false,
        cartData: {
          ...state.cartData,
          numTransfers,
          remainingChildTransactions
        }
      };
    }

    case getType(CartActions.changeOpenShopQuantity): {
      return {
        ...state,
        openCartItemCount: action.payload.qty
      };
    }

    default:
      return state;
  }
}
